import axiosapi from "./axiosAPI";

// Get All IncidentStatus
export const getAllIncidentStatuses = async (
    setIncidentStatuses,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/statuses");
        setIncidentStatuses(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch IncidentStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch IncidentStatus");
		}
		
	}
	
};



// Get One IncidentStatus
export const getOneIncidentStatus = async (
    pkid,
    setFetcherror,  
    setIncidentStatus
    
)=>{
	try{
		const res =await axiosapi.get(`/statuses/${pkid}`);
        setIncidentStatus(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch IncidentStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch IncidentStatus");
		}
		
	}
	
};


// Create New IncidentStatus
export const createIncidentStatus = async (
    incidentStatus,
    setIncidentStatus,
    setFetcherror,
    handleAllToasts,
    setIncidentStatuses

) => {

    if (!incidentStatus ) {
        handleAllToasts(2, "No IncidentStatus Provided"); 
            return; 
        }

    const PushItem = {
            name: incidentStatus,
        };

    try{
        await axiosapi.post("/statuses/",PushItem );
        setIncidentStatus("");
        handleAllToasts(1, "IncidentStatus Created Successfully");
        getAllIncidentStatuses(setIncidentStatuses,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New IncidentStatus");
            handleAllToasts(2, "Could Not update The IncidentStatus");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New IncidentStatus");
            handleAllToasts(2, "Could Not update The IncidentStatus");
            
        }
        
    }
    
}


// Edit Existing IncidentStatus

export const editIncidentStatus = async (
    incidentStatuspkid,
    incidentStatus,
    setIncidentStatus,
    setFetcherror,
    handleAllToasts,
    setIncidentStatuses
              
        ) => {

            if (!incidentStatus) {
                handleAllToasts(2, "No IncidentStatus Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:incidentStatuspkid,
                    name: incidentStatus,
                };

            try{
                await axiosapi.patch("/statuses/",PushItem );
                setIncidentStatus("");
                handleAllToasts(1, "IncidentStatus Updated Successfully");
                getAllIncidentStatuses(setIncidentStatuses,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update IncidentStatus");
                    handleAllToasts(2, "Could Not Update IncidentStatus");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update IncidentStatus");
                    handleAllToasts(2, "Could Not Update IncidentStatus");
                    
                }
                
            }
            
};



// Delete Existing IncidentStatus.

export const deleteIncidentStatus = async (
    incidentStatuspkid,
    setIncidentStatuses,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/statuses/${incidentStatuspkid}`);
        let finalData = res.data.message;
        getAllIncidentStatuses(setIncidentStatuses, setFetcherror);
        handleAllToasts(1, "IncidentStatus Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete IncidentStatus");
            handleAllToasts(2,"Error: Could Not Delete IncidentStatus");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete IncidentStatus");
            handleAllToasts(2,"Error: Could Not Delete IncidentStatus");
		}
		
	}
	
};